import React, { useRef, useState } from 'react'
import './AdCallRecordsStyle.css';
import Button from '../../../components/Button/Button';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdownmenu from '../../../components/Dropdownmenu/Dropdownmenu';
// import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import Deletepoup from '../../../components/Popups/Deletepoup/Deletepoup';
import ViewCallDetails from '../../../components/Popups/ViewCallDetails/ViewCallDetails';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { adminData, clearState, deleteMentorInterviewSlot, getAllOngoingCalls, getAllPastCalls, getAllUpcomingCalls, getFeedbackAnswers, notifyUser } from '../../../reducer/adminSlice';
import { useEffect } from 'react';
import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import moment from 'moment';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow';
import Dorpwoncustom from '../../../components/Dorpwoncustom/Dorpwoncustom';
import SuccessToast from '../../../components/Toast/SuccessToast';
import ErrorToast from '../../../components/Toast/ErrorToast';
import Skeleton from 'react-loading-skeleton';
import QuestionPopup from '../../../components/Popups/QuestionPopup/QuestionPopup';



const CallHistory = () => {

    const statusOptions = [
        {
            label: "All",
            value: ""
        },
        {
            label: "Completed",
            value: "completed"
        },
        {
            label: "Cancelled",
            value: "cancelled"
        },
        {
            label: "Rescheduled",
            value: "rescheduled"
        },
        {
            label: "Unattended",
            value: "pending"
        },
    ];

    //dropdown
    const options = [
        {
            label: 'Working Professional',
            value: 'work'
        },
        {
            label: 'Student',
            value: 'student'
        },
    ];
    const [Dropdownlist, setDropdownlist] = useState();

    //delete states
    const [selectedSlot, setSelectedSlot] = useState("")

    // const [viewCallDetails, setViewCallDetails] = useState();
    const [viewdelete, setViewdelete] = useState();
    const [viewdropdown, setviewdropdown] = useState()

    const [tabToggler, setTabToggler] = useState(1);

    //Search states
    const [search, setSearch] = useState("");

    //Filter States
    const [filterToggler, setFilterToggler] = useState(false);
    const [program, setProgram] = useState("");
    const [date, setDate] = useState("");
    const [status, setStatus] = useState("");

    //Load more states
    const [index, setIndex] = useState(1);
    const [totalUpcomingCalls, setTotalUpcomingcalls] = useState([]);
    const [totalPastCalls, setTotalPastCalls] = useState([]);
    const [totalOngoingCalls, setTotalOngoingCalls] = useState([]);

    //Question states
    const [viewQuestions, setViewQuestions] = useState(false);
    const [callDetail, setCallDetail] = useState({});

    //View call details states
    const [viewCallDetails, setViewCallDetails] = useState(false);
    const [menteeFeedback, setMenteeFeedback] = useState({});
    const [mentorFeedback, setMentorFeedback] = useState({});

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const { isUpcomingFetching, isPastFetching, isOngoingFetching, isLoaderFetching, isSuccess, isError, errorMessage, allUpcomingCalls, allPastCalls, feedback, allOngoingCalls, isUserNotified } = useSelector(adminData);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    //Delete functions
    const handleDeleteSlot = () => {
        dispatch(deleteMentorInterviewSlot(selectedSlot));
    };

    const handleCloseDelete = () => {
        setViewdelete(false);
        setSelectedSlot("");
    };

    //Question functions
    const handleQuestionsClose = () => {
        setViewQuestions(false);
        setTimeout(() => {
            setCallDetail({});
        },200)
    };

    //View Call details Functions
    const handleViewCallDetails = (id) => {
        setViewCallDetails(true);
        dispatch(getFeedbackAnswers(id));
    };

    const handleViewCallClose = () => {
        setViewCallDetails(false);
        setMenteeFeedback({});
        setMentorFeedback({});
    };

    //Search functions
    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
    };

    const handleSearch = (e) => {
        setTotalPastCalls([]);
        setTotalUpcomingcalls([]);
        setIndex(1);
        if (tabToggler === 1) dispatch(getAllUpcomingCalls({ search, date, program, status }));
        if (tabToggler === 2) dispatch(getAllOngoingCalls({ search, date, program, status }));
        if (tabToggler === 3) dispatch(getAllPastCalls({ search, date, program, status }));
    };

    const handleSearchPress = (e) => {
        if (e.key === "Enter") {
            setTotalPastCalls([]);
            setTotalUpcomingcalls([]);
            setIndex(1);
            if (tabToggler === 1) dispatch(getAllUpcomingCalls({ search, date, program, status }));
            if (tabToggler === 2) dispatch(getAllOngoingCalls({ search, date, program, status }));
            if (tabToggler === 3) dispatch(getAllPastCalls({ search, date, program, status }));
        }
    };

    //Filter functions
    const handleProgramFilter = (e) => {
        const { value } = e.target;
        setProgram(value);
    };

    const handleDateFilter = (e) => {
        const { value } = e.target;
        setDate(value);
    };

    const handleStatusFilter = (status) => {
        setStatus(status);
    };

    //Load more functions
    const handleLoadMore = () => {
        setIndex(prev => prev + 1);
        if (tabToggler === 1) dispatch(getAllUpcomingCalls({ search, date, program, index: index + 1 }))
        if (tabToggler === 2) dispatch(getAllOngoingCalls({ search, date, program, status, index: index + 1 }));
        if (tabToggler === 3) dispatch(getAllPastCalls({ search, date, program, status, index: index + 1 }));
    };

    //View call details useEffect
    useEffect(() => {
        if (feedback?.feedbackAnswers?.length > 0) {
            const menteeArr = feedback?.feedbackAnswers?.filter((item) => item.menteeId);
            const mentorArr = feedback?.feedbackAnswers?.filter((item) => item.mentorId);
            setMenteeFeedback(...menteeArr);
            setMentorFeedback(...mentorArr);
        }
    }, [feedback]);

    //Load more useEffects
    useEffect(() => {
        if (index === 1 && allUpcomingCalls?.calls?.length > 0) setTotalUpcomingcalls(allUpcomingCalls?.calls);
        if (index === 1 && allPastCalls?.calls?.length > 0) setTotalPastCalls(allPastCalls?.calls);
        if (index === 1 && allOngoingCalls?.calls?.length > 0) setTotalOngoingCalls(allOngoingCalls?.calls);
        if (index !== 1 && allUpcomingCalls?.calls?.length > 0) setTotalUpcomingcalls(prev => [...prev, ...allUpcomingCalls?.calls]);
        if (index !== 1 && allPastCalls?.calls?.length > 0) setTotalPastCalls(prev => [...prev, ...allPastCalls?.calls]);
        if (index !== 1 && allOngoingCalls?.calls?.length > 0) setTotalOngoingCalls(prev => [...prev, ...allOngoingCalls?.calls]);
    }, [allUpcomingCalls, allPastCalls, allOngoingCalls]);

    //Filter useEffect
    useEffect(() => {
        setIndex(1);
        setTotalPastCalls([]);
        setTotalUpcomingcalls([]);
        setTotalOngoingCalls([]);
        if (tabToggler === 1) dispatch(getAllUpcomingCalls({ search, date, program, status }));
        if (tabToggler === 2) dispatch(getAllOngoingCalls({ search, date, program, status }));
        if (tabToggler === 3) dispatch(getAllPastCalls({ search, date, program, status }));
    }, [date, status, tabToggler]);

    useEffect(() => {
        if (isSuccess) {
            setIsShowSuccess(true);
            setSuccessMessage("Success!");
            setViewdelete(false);
            setTotalPastCalls([]);
            setTotalUpcomingcalls([]);
            setTotalOngoingCalls([]);
            if (tabToggler === 1) dispatch(getAllUpcomingCalls({}))
            if (tabToggler === 2) dispatch(getAllOngoingCalls({}));
            if (tabToggler === 3) dispatch(getAllPastCalls({}));
            setTabToggler(1);
            dispatch(clearState());
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isUserNotified) {
            dispatch(clearState());
            setTotalOngoingCalls([])
            dispatch(getAllOngoingCalls({ search }));
        }
    }, [isUserNotified]);

    useEffect(() => {
        if (isError) {
            setTotalPastCalls([]);
            setTotalUpcomingcalls([]);
            setIndex(1);
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    }, [isError]);

    const targetRef = useRef(null);

    useEffect(() => {

        const allElements = document.querySelectorAll(".CallHistoryTabledata");
        const allElements1 = document.querySelectorAll(".innerdiv");

        let element = allElements[0];
        let element1 = allElements1[0];
        if (tabToggler === 1) {
            element = allElements[0];
            element1 = allElements1[0];
        };
        if (tabToggler === 2) {
            element = allElements[1];
            element1 = allElements1[1];
        };
        if (tabToggler === 3) {
            element = allElements[2];
            element1 = allElements1[2];
        };

        const handleScroll = () => {
            console.log("pj")
            if (targetRef.current) {
                const { top } = targetRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                if (top <= windowHeight) {
                    handleLoadMore();
                }
            }
        };

        element.addEventListener('scroll', handleScroll);
        element1.addEventListener('scroll', handleScroll);

        return () => {
            element.removeEventListener('scroll', handleScroll);
            element1.removeEventListener('scroll', handleScroll);
        };
    }, [handleLoadMore]);

    return (
        <>
            {isLoaderFetching && <PageLoader />}
            <ErrorToast
                show={isShowError}
                setShow={() => setIsShowError(false)}
                message={errMessage}
            />
            <SuccessToast
                show={isShowSuccess}
                setShow={() => setIsShowSuccess(false)}
                message={successMessage}
            />
            <Deletepoup isActive={viewdelete} setIsActive={setViewdelete} handleClose={handleCloseDelete} handleDelete={handleDeleteSlot} />
            <ViewCallDetails isActive={viewCallDetails} setIsActive={setViewCallDetails} menteeFeedback={menteeFeedback} mentorFeedback={mentorFeedback} callInfo={feedback} handleClose={handleViewCallClose} />
            {/* <QuestionPopup isActive={viewQuestions} handleClose={handleQuestionsClose} callDetail={callDetail} /> */}
            <div className="callHIstoryWrap tablemobsizefix">

                <div className="headingwrap flex-between">
                    <div>
                        <h2 className='heading-2 mb6'>Call Records</h2>
                        {<p className='text3'>Total {tabToggler === 1 ? allUpcomingCalls?.totalCount ?? 0 : tabToggler === 2 ? allOngoingCalls?.totalCount ?? 0 : allPastCalls?.totalCount ?? 0}</p>}
                    </div>

                    <div className="btnRightsidesale pillButtons btnfixvip">
                        <Button className={tabToggler === 1 && 'active'} name={'Upcoming'} onClick={() => setTabToggler(1)} />
                        <Button className={tabToggler === 2 && 'active'} name={'Ongoing'} onClick={() => setTabToggler(2)} />
                        <Button className={tabToggler === 3 && 'active'} name={'Past'} onClick={() => setTabToggler(3)} />
                    </div>
                </div>
                <div className={`commonTableWrapper AdcommonWrapperforAll`}>
                    <div className="FaqUserFiltter flex-between">
                        {<SearchBar placeholder={'Search by Name'} value={search} onChange={handleSearchChange} onKeyDown={handleSearchPress} onClick={handleSearch} className={'searchbardesign'} />}
                        <div className="FilterButtonPast flex gap-10 dropcallrecord" >
                            {<div className='dropdownbtnshow'>
                                <input type='text' placeholder={`Showing ${tabToggler === 1 ? totalUpcomingCalls?.length ?? 0 : tabToggler === 2 ? totalOngoingCalls?.length ?? 0 : totalPastCalls?.length ?? 0} out of ${tabToggler === 1 ? allUpcomingCalls?.totalCount ?? 0 : tabToggler === 2 ? allOngoingCalls?.totalCount ?? 0 : allPastCalls?.totalCount ?? 0}`} disabled className='disabledInput' />
                                {/* <Dorpwoncustom isActive={Dropdownlist} setIsActive={setDropdownlist} placeholder={'Showing 10 of 12'} options={options} /> */}
                            </div>}
                            {tabToggler !== 2 && (<label htmlFor="date" className='Cudatedesign'>
                                <input type="date" value={date} placeholder="dd/mm/yyyy" id='date' min={tabToggler === 1 && moment().format("YYYY-MM-DD")} max={tabToggler === 3 && moment().format("YYYY-MM-DD")} onChange={handleDateFilter} />
                            </label>)}
                        </div>
                    </div>

                    <div className={`CallHistoryTabledata mt20 Tabusesate mobrcallfix1 ${tabToggler === 1 && 'active'}`}>

                        <div className="outerdiv">
                            <table>
                                <thead>
                                    <tr className='headingTabletr'>
                                        <th>Mentor</th>
                                        <th>Mentee</th>
                                        <th>Program</th>
                                        <th>Agenda</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                        {/* <th>Action</th> */}
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <div className={`innerdiv callrsbodyfix`}>
                            <table>
                                <tbody>
                                    {totalUpcomingCalls?.length > 0 ? totalUpcomingCalls?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="tableBox">
                                                    <div className='Adminprofileimageuser'>
                                                        <img src={item?.mentor?.profileImg ? item?.mentor?.profileImg : "/assets/img/User.png"} alt="" className='pointer' onClick={() => navigate(`/admin/mentor-profile/${item?.mentor?.id}`)} />
                                                    </div>
                                                    <div className='Namedetails'>
                                                        <h4 className='namelink mb4 navigatetext' onClick={() => navigate(`/admin/mentor-profile/${item?.mentor?.id}`)}>{item?.mentor?.firstName ? `${item?.mentor?.firstName} ${item?.mentor?.lastName}` : "---"}</h4>
                                                        <p className="text2">{item?.mentor?.profession?.designation ? item?.mentor?.profession?.designation : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <div className='Adminprofileimageuser'>
                                                        <img src={item?.mentee?.profileImg ? item?.mentee?.profileImg : "/assets/img/User.png"} alt="" className='pointer' onClick={() => navigate(`/admin/mentee-profile/${item?.id}`)} />
                                                    </div>
                                                    <div className='Namedetails' >
                                                        <h4 className='namelink mb4 navigatetext' onClick={() => navigate(`/admin/mentee-profile/${item?.mentee?.id}`)}>{item?.mentee?.firstName ? `${item?.mentee?.firstName} ${item?.mentee?.lastName}` : "---"}</h4>
                                                        <p className="text2">{item?.mentee?.profession?.title ? item?.mentee?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>{item?.program?.programName ? item?.program?.programName : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>{item?.agenda ? item?.agenda : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox dsblock'>
                                                    <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("DD MMMM") : "---"}</h4>
                                                    <p className='text2'>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("dddd") : "---"}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}</h4>
                                                </div>
                                            </td>
                                            {/* <td>
                                                <div className="tableBox">
                                                    <span className="tooltip pointer" data-tooltip="Questions" onClick={() => {setViewQuestions(true); setCallDetail(item)}} >
                                                        <img src="/assets/img/eye.png" alt="" />
                                                    </span>
                                                </div>
                                            </td> */}
                                        </tr>
                                    )) : !isUpcomingFetching && <DatanotFound />}
                                    {isUpcomingFetching &&
                                        <>
                                            {[1, 2, 3, 4, 5].map(item => (
                                                <tr key={item}>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className='Namedetails'>
                                                                <h4 className='namelink mb4 navigatetext' >{<Skeleton width={"100px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"100px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className='Namedetails'>
                                                                <h4 className='namelink mb4 navigatetext' >{<Skeleton width={"100px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"100px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox'>
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox'>
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox dsblock'>
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                            <p className='text2'>{<Skeleton width={"80px"} />}</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>}
                                </tbody>
                            </table>
                        </div>

                        {((!isUpcomingFetching && !isPastFetching && !isOngoingFetching) && ((totalUpcomingCalls?.length < allUpcomingCalls?.totalCount && tabToggler === 1) || (totalPastCalls?.length < allPastCalls?.totalCount && tabToggler === 3) || (totalOngoingCalls?.length < allOngoingCalls?.totalCount && tabToggler === 2))) && <div className="lodeemorebutton mt10" ref={targetRef}>
                            <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                        </div>}
                    </div>

                    <div className={`CallHistoryTabledata mt20 Tabusesate mobrcallfix2 ${tabToggler === 2 && 'active'}`}>
                        <div className='outerdiv'>
                            <table>
                                <thead>
                                    <tr className='headingTabletr'>
                                        <th>Agenda</th>
                                        <th>Programme</th>
                                        <th>Time</th>
                                        <th>Mentor</th>
                                        <th>Mentee</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <div className={`innerdiv callrsbodyfix`}>
                            <table>
                                <tbody>
                                    {isOngoingFetching ?
                                        <>
                                            {[1, 2, 3, 4, 5].map(item => (
                                                <tr key={item}>

                                                    <td>
                                                        <div className='tableBox'>
                                                            <h4>{<Skeleton width={"250px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox dsblock'>
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className="ProfileMnmainbtn">
                                                                <div className='Namedetails'>
                                                                    <h4 className='namelink mb4 navigatetext' >{<Skeleton width={"100px"} />}</h4>
                                                                    <p className="text2">{<Skeleton width={"150px"} />}</p>
                                                                </div>
                                                                {/* {item?.isMentorJoined ? <span className='joined text2'>Joined</span> : item?.isMentorNotified ? <span className='notified text2'>Notified</span> : <Button name={'Notify'} className={'notifybtn'} onClick={() => dispatch(notifyUser({ bookingId: item?.id, userId: item?.mentee?.id }))} />} */}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className="ProfileMnmainbtn">
                                                                <div className='Namedetails'>
                                                                    <h4 className='namelink mb4 navigatetext' >{<Skeleton width={"100px"} />}</h4>
                                                                    <p className="text2">{<Skeleton width={"150px"} />}</p>
                                                                </div>
                                                                {/* {item?.isMenteeJoined ? <span className='joined text2'>Joined</span> : item?.isMentorNotified ? <span className='notified text2'>Notified</span> : <Button name={'Notify'} className={'notifybtn'} onClick={() => dispatch(notifyUser({ bookingId: item?.id, userId: item?.mentee?.id }))} />} */}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </> :
                                        totalOngoingCalls?.length > 0 ? totalOngoingCalls?.map((item, index) => (
                                            <tr key={index}>

                                                <td>
                                                    <div className='tableBox'>
                                                        <h4>{item?.agenda ? item?.agenda : "---"}</h4>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='tableBox dsblock'>
                                                        <h4>{item?.program?.programName ? item?.program?.programName : "---"}</h4>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="tableBox">
                                                        <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}</h4>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="tableBox">
                                                        <div className='Adminprofileimageuser'>
                                                            <img src={item?.mentor?.profileImg ? item?.mentor?.profileImg : "/assets/img/User.png"} alt="" className='pointer' />
                                                        </div>
                                                        <div className="ProfileMnmainbtn">
                                                            <div className='Namedetails'>
                                                                <h4 className='namelink mb4 navigatetext' >{item?.mentor?.firstName ? `${item?.mentor?.firstName} ${item?.mentor?.lastName}` : "---"}</h4>
                                                                <p className="text2">{item?.mentor?.profession?.designation ? item?.mentor?.profession?.designation : "---"}</p>
                                                            </div>
                                                            {item?.isMentorJoined ? <span className='joined text2'>Joined</span> : item?.isMentorNotified ? <span className='notified text2'>Notified</span> : <Button name={'Notify'} className={'notifybtn'} onClick={() => dispatch(notifyUser({ bookingId: item?.id, userId: item?.mentee?.id }))} />}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="tableBox">
                                                        <div className='Adminprofileimageuser'>
                                                            <img src={item?.mentee?.profileImg ? item?.mentee?.profileImg : "/assets/img/User.png"} alt="" className='pointer' />
                                                        </div>
                                                        <div className="ProfileMnmainbtn">
                                                            <div className='Namedetails' >
                                                                <h4 className='namelink mb4 navigatetext'>{item?.mentee?.firstName ? `${item?.mentee?.firstName} ${item?.mentee?.lastName}` : "---"}</h4>
                                                                <p className="text2">{item?.mentee?.profession?.title ? item?.mentee?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                                            </div>

                                                            {item?.isMenteeJoined ? <span className='joined text2'>Joined</span> : item?.isMenteeNotified ? <span className='notified text2'>Notified</span> : <Button name={'Notify'} className={'notifybtn'} onClick={() => dispatch(notifyUser({ bookingId: item?.id, userId: item?.mentor?.id }))} />}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : <DatanotFound />}
                                </tbody>
                            </table>
                        </div>

                        {((!isUpcomingFetching && !isPastFetching && !isOngoingFetching) && ((totalUpcomingCalls?.length < allUpcomingCalls?.totalCount && tabToggler === 1) || (totalPastCalls?.length < allPastCalls?.totalCount && tabToggler === 3) || (totalOngoingCalls?.length < allOngoingCalls?.totalCount && tabToggler === 2))) && <div className="lodeemorebutton mt10" ref={targetRef}>
                            <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                        </div>}
                    </div>

                    <div className={`CallHistoryTabledata mt20 Tabusesate mobrcallfix3 ${tabToggler === 3 && 'active'}`}>

                        <div className="outerdiv">
                            <table>
                                <thead>
                                    <tr className='headingTabletr'>
                                        <th>Mentor</th>
                                        <th>Mentee</th>
                                        <th>Program</th>
                                        <th>Agenda</th>
                                        <th>
                                            <div className='dropdownwrapper flex pointer' onClick={() => setviewdropdown(!viewdropdown)}>Status
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.4534 4.77173H6.81926H3.54676C2.98676 4.77173 2.70676 5.4484 3.10343 5.84506L6.1251 8.86673C6.60926 9.35089 7.39676 9.35089 7.88093 8.86673L9.0301 7.71756L10.9026 5.84506C11.2934 5.4484 11.0134 4.77173 10.4534 4.77173Z" fill="#737373" />
                                                </svg>
                                                <Dropdownmenu setviewdropdown={setviewdropdown} viewdropdown={viewdropdown} options={statusOptions} onChange={handleStatusFilter} />
                                            </div>
                                        </th>

                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>Actions</th>
                                    </tr>

                                </thead>
                            </table>
                        </div>

                        <div className="innerdiv callrsbodyfix">
                            <table>
                                <tbody>
                                    {totalPastCalls?.length > 0 ? totalPastCalls?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="tableBox">
                                                    <div className='Adminprofileimageuser'>
                                                        <img src={item?.mentor?.profileImg ? item?.mentor?.profileImg : "/assets/img/User.png"} alt="" className='pointer' onClick={() => navigate(`/admin/mentor-profile/${item?.mentor?.id}`)} />
                                                    </div>
                                                    <div className='Namedetails'>
                                                        <h4 className='namelink mb4 navigatetext' onClick={() => navigate(`/admin/mentor-profile/${item?.mentor?.id}`)}>{item?.mentor?.firstName ? `${item?.mentor?.firstName} ${item?.mentor?.lastName}` : "---"}</h4>
                                                        <p className="text2">{item?.mentor?.profession?.designation ? item?.mentor?.profession?.designation : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <div className='Adminprofileimageuser'>
                                                        <img src={item?.mentee?.profileImg ? item?.mentee?.profileImg : "/assets/img/User.png"} alt="" className='pointer' onClick={() => navigate(`/admin/mentee-profile/${item?.mentee?.id}`)} />
                                                    </div>
                                                    <div className='Namedetails'>
                                                        <h4 className='namelink mb4 navigatetext' onClick={() => navigate(`/admin/mentee-profile/${item?.mentee?.id}`)}>{item?.mentee?.firstName ? `${item?.mentee?.firstName} ${item?.mentee?.lastName}` : "---"}</h4>
                                                        <p className="text2">{item?.mentee?.profession?.title ? item?.mentee?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>{item?.program?.programName ? item?.program?.programName : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>{item?.agenda ? item?.agenda : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <div className='mentorProfilearea'>
                                                        <h4 className={`${item?.meetingStatus?.toLowerCase()} Statuscheck capitilize`}>{item?.meetingStatus ? item?.meetingStatus === "pending" ? 'No Show' : item?.meetingStatus : "---"}</h4>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <div className='dsblock'>
                                                        <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("DD MMMM") : "---"}</h4>
                                                        <p className="text2">{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("dddd") : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}</h4>
                                                </div>
                                            </td>

                                            <td>
                                                <div className="tableBox">
                                                    <span className="tooltip calendar pointer " data-tooltip="View feedback">
                                                        <img src="/assets/img/eye.png" alt="" onClick={() => handleViewCallDetails(item?.id)} />
                                                    </span>
                                                    <span className='tooltip pointer' data-tooltip="Delete" onClick={() => { setViewdelete(true); setSelectedSlot(item?.id) }}>
                                                        <img src="/assets/svg/trash.svg" alt="" />
                                                    </span>
                                                </div>
                                            </td>

                                        </tr>
                                    )) : !isPastFetching && <DatanotFound />}
                                    {isPastFetching &&
                                        <>
                                            {[1, 2, 3, 4].map(item => (
                                                <tr key={item}>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className='Namedetails'>
                                                                <h4 className='namelink mb4 navigatetext'>{<Skeleton width={"60px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"100px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className='Namedetails'>
                                                                <h4 className='namelink mb4 navigatetext'>{<Skeleton width={"60px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"100px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox'>
                                                            <h4>{<Skeleton width={"150px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox'>
                                                            <div className='mentorProfilearea'>
                                                                <h4 className={`Statuscheck capitilize`}>{<Skeleton width={"120px"} />}</h4>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='tableBox dsblock'>
                                                                <h4>{<Skeleton width={"100px"} />}</h4>
                                                                <p className='text2'>{<Skeleton width={"80px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="tableBox">
                                                            {<Skeleton width={"20px"} height={"20px"} circle />}
                                                            {<Skeleton width={"20px"} height={"20px"} circle />}
                                                        </div>
                                                    </td>

                                                </tr>
                                            ))}
                                        </>}
                                </tbody>
                            </table>
                            {((!isUpcomingFetching && !isPastFetching && !isOngoingFetching) && ((totalUpcomingCalls?.length < allUpcomingCalls?.totalCount && tabToggler === 1) || (totalPastCalls?.length < allPastCalls?.totalCount && tabToggler === 3) || (totalOngoingCalls?.length < allOngoingCalls?.totalCount && tabToggler === 2))) && <div className="lodeemorebutton mt10" ref={targetRef}>
                                <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                            </div>}
                        </div>

                        {/* {((!isUpcomingFetching && !isPastFetching && !isOngoingFetching) && ((totalUpcomingCalls?.length < allUpcomingCalls?.totalCount && tabToggler === 1) || (totalPastCalls?.length < allPastCalls?.totalCount && tabToggler === 3) || (totalOngoingCalls?.length < allOngoingCalls?.totalCount && tabToggler === 2))) && <div className="lodeemorebutton mt10" ref={targetRef}>
                            <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                        </div>} */}
                    </div>
                </div>
            </div>
        </>

    )
}

export default CallHistory